import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LocaleManager } from "abweb/service/locale/LocaleManager";
import { weekStartLocale } from "abweb/utils/date/internal/WeekStart";
import { Info } from "luxon";

/**
 * Internal class used to for localized Calendar reasoning (e.g. localized day/month names and start of week).
 */
export class CalendarUtils {
  // private constructor because the class is static
  constructor() {}

  /**
   * @return first day of week via DayOfWeek enum (0=Sunday, ... 6: Saturday) for current date time locale
   */
  static get firstDay() {
    return CalendarUtils.weekFirstDay;
  }

  /**
   * Gets an array of full month names in the current culture's language.
   * January, February, March, ... for en-US.
   */
  static get months() {
    return CalendarUtils.monthsLong;
  }
  static resetStatics() {
    LocaleManager.registerAndInvokeSyncLocaleListener(localeState => CalendarUtils.onLocaleChange(localeState.datetimeFormatLocale));
  }

  /**
   * Gets a single month name in the current culture's language.
   * Indexes with at 0 = January, 1 = February, ... for en-US.
   */
  static monthName(month) {
    return CalendarUtils.monthsLong[month];
  }

  /**
   * Gets a month's number from its name.
   * Indexes with at 0 = January, 1 = February, ... for en-US.
   */
  static monthNumber(month) {
    return CalendarUtils.monthsLong.indexOf(month);
  }

  /**
   * Gets short form day of the week names.
   * Su, Mo, Tu... for en-US.
   */
  static dayNameShort(day) {
    return CalendarUtils.weekdaysShort[day];
  }
  static onLocaleChange(datetimeFormatLocale) {
    if (datetimeFormatLocale === CalendarUtils.datetimeLocale) {
      return;
    }
    CalendarUtils.datetimeLocale = datetimeFormatLocale;
    CalendarUtils.weekFirstDay = weekStartLocale(CalendarUtils.datetimeLocale);
    CalendarUtils.monthsLong = Info.months("long", {
      locale: CalendarUtils.datetimeLocale
    });
    const luxonWeekdaysShort = Info.weekdays("short", {
      locale: CalendarUtils.datetimeLocale
    })
    // luxon sources locale data from browser, and
    // older browser (e.g. Chrome79) will sometimes have trailing '.' in daynameShort, so remove it (lun. becomes lun)
    .map(shortDay => shortDay.endsWith(".") ? shortDay.substring(0, shortDay.length - 1) : shortDay);

    // Luxon has Monday as day 0, while our DayOfWeek apis use Sunday as day 0.  So 'rotate right' the array
    luxonWeekdaysShort.unshift(luxonWeekdaysShort.pop());
    CalendarUtils.weekdaysShort = luxonWeekdaysShort;
    console.log(`CalendarInternals.datetimeFormatLocale is '${datetimeFormatLocale}'`);
  }
}

// Outside of class to guarantee that it is 'last' (even when intellij reorders static class members!)
// noinspection JSUnusedLocalSymbols
// Holds native browser datetime locale.   Real implementation (SOR) will be backed by LocaleManager.datetimeFormatLocale
_defineProperty(CalendarUtils, "datetimeLocale", void 0);
_defineProperty(CalendarUtils, "weekFirstDay", void 0);
_defineProperty(CalendarUtils, "monthsLong", void 0);
_defineProperty(CalendarUtils, "weekdaysShort", void 0);
const staticInitializer = CalendarUtils.resetStatics();
//# sourceMappingURL=CalendarUtils.js.map
